import React from 'react';
import { Link } from 'react-router-dom';
import { HeartIcon, PlusIcon } from 'lucide-react';
import { toast } from 'sonner';
import { useCart } from '../../contexts/CartContext';
import { useWishlist } from '../../contexts/WishlistContext';
import { getCreator } from '../../utils/catalog';
import { formatPrice } from '../../utils/currency';
import type { Product } from '../../types/catalog';
import { ProductTags } from './ProductTags';
export function ProductCard({
  product
}: {
  product: Product;
}) {
  const creator = getCreator(product.creatorId);
  const {
    addItem
  } = useCart();
  const {
    has,
    toggle
  } = useWishlist();
  const liked = has(product.id);
  const onWishlist = () => {
    const added = toggle(product.id);
    toast(added ? 'Ajouté à vos favoris' : 'Retiré de vos favoris', {
      description: product.name
    });
  };
  return <article className="group relative flex h-full flex-col" data-id="element-534" data-mp="2fa6ii7gcl77j">
      <div className="relative aspect-[4/5] overflow-hidden rounded-sm bg-shell" data-id="element-535" data-mp="2k8hw8t9rk1v1">
        <Link to={`/produit/${product.id}`} className="block h-full" aria-label={product.name} data-id="element-536" data-mp="4bxnyotwpmg5">
          <img src={product.images[0]} alt={product.name} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-537" data-mp="9b00z0cwlo8" />
          {product.images[1] && <img src={product.images[1]} alt="" aria-hidden loading="lazy" className="absolute inset-0 hidden h-full w-full object-cover opacity-0 transition-opacity duration-300 ease-out group-hover:opacity-100 md:block" data-id="element-538" data-mp="nz5a58tajw4s" />}
        </Link>
        <ProductTags product={product} data-id="element-539" data-mp="99pou8cj4iwh" />
        <button type="button" onClick={onWishlist} aria-pressed={liked} aria-label={liked ? `Retirer ${product.name} des favoris` : `Ajouter ${product.name} aux favoris`} className="absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-full bg-paper/90 transition-transform duration-150 ease-out active:scale-90" data-id="element-540" data-mp="98oc7zfv7ocn">
          <HeartIcon className={`h-4 w-4 ${liked ? 'fill-clay text-clay' : 'text-ink'}`} data-id="element-541" data-mp="30aq027jsiwzq" />
        </button>
        <div className="absolute inset-x-3 bottom-3 hidden translate-y-2 opacity-0 transition-[transform,opacity] duration-200 ease-out focus-within:translate-y-0 focus-within:opacity-100 group-hover:translate-y-0 group-hover:opacity-100 md:block" data-id="element-542" data-mp="2mfe7a5p73glg">
          {product.options ? <Link to={`/produit/${product.id}`} className="flex h-11 w-full items-center justify-center rounded-full bg-paper text-sm font-medium text-ink hover:bg-ink hover:text-paper" data-id="element-543" data-mp="2hjff070qxefr">
              Choisir {product.options.label.toLowerCase()}
            </Link> : <button type="button" onClick={() => addItem(product.id, 1)} className="flex h-11 w-full items-center justify-center gap-1.5 rounded-full bg-paper text-sm font-medium text-ink transition-colors duration-150 hover:bg-ink hover:text-paper" data-id="element-544" data-mp="6q2rwmc11wf6">
              <PlusIcon className="h-4 w-4" data-id="element-545" data-mp="pmbfvjr26ake" /> Ajout rapide
            </button>}
        </div>
      </div>
      <div className="mt-3 flex flex-1 flex-col" data-id="element-546" data-mp="kv31saesa10w">
        {creator && <Link to={`/createurs/${creator.id}`} className="text-xs text-muted transition-colors duration-150 hover:text-clay" data-id="element-547" data-mp="zkirro6hq2fj">
            {creator.name}
          </Link>}
        <h3 className="mt-1 text-[15px] leading-snug" data-id="element-548" data-mp="unilpd9n4zof">
          <Link to={`/produit/${product.id}`} className="hover:text-clay" data-id="element-549" data-mp="18lgv0493u5x2">
            {product.name}
          </Link>
        </h3>
        <p className="mt-auto pt-1.5 text-sm font-medium tabular-nums" data-id="element-550" data-mp="14kdinrq9ms0l">{formatPrice(product.price)}</p>
      </div>
    </article>;
}